import { SELECIONAR_TRECHO_PASSAGEIRO } from '../../actions/types'

const initialState = undefined;
const estadoInicial = {label: '', value: null};

export default function reducerTrechoPassageiroSelecionado (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_TRECHO_PASSAGEIRO: {
      if (action.payload) {
        return action.payload;
      }
      return estadoInicial
    }

    default: {
      return state
    }
  }
}
